import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const TwoWaySmsModalContent: FC = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        {t("Not everyone lives in email or chat. SMS meets people where they are.")}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "For employees in the field or always on the move, SMS is the fastest, most reliable way to reach them and give them a voice.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t("With Two-Way SMS, you can:")}
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            {t("Send time-sensitive messages that actually get seen")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("Allow employees to reply directly by text - no apps or logins")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("View and manage responses inside ChangeEngine")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("Understand what landed with built-in engagement analytics")}
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "Use it for quick check-ins, confirmations, reminders, or simple back-and-forth—whether you’re messaging one team or your entire workforce.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t("Simple. Personal. Actionable.")}
      </Typography>
    </Box>
  );
};
